import React from 'react';
import PoolBalanceChart from '../components/PoolBalanceChart';
import DepositorListTable from '../components/deposit/DepositorListTable';

const Depositor: React.FC = () => {
  return (
    <div className="min-h-screen p-4 sm:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-2xl sm:text-3xl mb-4 sm:mb-6 font-borna text-black dark:text-white">Depositor</h1>
        <div className="grid grid-cols-1 gap-4 sm:gap-6">
          <PoolBalanceChart />
          <DepositorListTable mode="detailed" />
        </div>
      </div>
    </div>
  );
};

export default Depositor; 